import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { Post } from '../../../types/Post';
import Api from '../../api/api';

export const unRecommendPost = async (postId: string): Promise<Post> => {
  const [response, bodyOrError] = await Api.patch(`posts/${postId}/unrecommend-post`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return response;
};

export const useUnRecommendPost = () => {
  const queryClient = useQueryClient();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation(
    'unRecommendPost',
    (data: { postId: string }) => {
      return unRecommendPost(data.postId);
    },
    {
      onSuccess: () => {
        setAlertSnackbar({
          message: 'Removed as recommended Post',
          severity: 'success',
          vertical: 'top',
        });
        queryClient.invalidateQueries(['getPostById']);
      },
    },
  );
};
